module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_chapel-45829bc77f0a94513490b947488fab1f.jpg";